import {useContext} from 'react';
import {ThemeContext} from '../../utils/ThemeContext';

const PartnersHeroSvg2 = () => {
  const {theme} = useContext(ThemeContext);
  const linearGradientID = theme === 'dark' ? 'url(#paint0)' : 'url(#paint1)';

  const svgContainerStyle = {
    position: 'absolute',
    left: 'calc(50% + 435px)',
    top: 'calc(50% - 260px)',
    width: '101',
    height: '238',
    transform: 'scale(1, -1) rotate(45deg)'
  };
  const pathStyle = {
    strokeDasharray: '1200',
    strokeDashoffset: '1200',
    animation: 'draw 2s ease-in-out forwards',
    animationDelay: '1s',
    stroke: linearGradientID,
    strokeWidth: '2',
    strokeLinecap: 'round'
  };

  return (
    <div style={svgContainerStyle}>
      <svg width='101' height='238' viewBox='0 0 101 238' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M1 1C58.9696 55.4615 100 137.608 100 237' style={pathStyle} />
        <defs>
          <linearGradient id='paint0' x1='111.669' y1='163.477' x2='-23.6288' y2='-4.05406' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#2463AC' />
            <stop offset='1' stopColor='#A3CDFF' stopOpacity='0' />
          </linearGradient>
          <linearGradient x1='138' y1='270' x2='-40.843' y2='3.52162' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#FE7518' />
            <stop offset='1' stopColor='#FE7518' stopOpacity='0' />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default PartnersHeroSvg2;

